import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { ToggleSwitchModule } from 'primeng/toggleswitch';
import { BaseControlComponent } from './base-control.component';
import { HelpTextComponent } from './help-text.component';
@Component({
  selector: 'app-toggle-switch',
  imports: [
    ReactiveFormsModule,
    CommonModule,
    ToggleSwitchModule,
    HelpTextComponent,
  ],
  template: `
    <div class="tw-flex tw-items-center tw-pr-2 ">
      @if (!rightLabel) {
        <label
          [for]="id"
          class="tw-mr-2 tw-pt-1 tw-cursor-pointer "
          [class]="classes"
          >{{ label }}
          @if (required) {
            <span aria-hidden="true"> *</span>
          }
        </label>
      }
      <p-toggleswitch
        [formControl]="control"
        [inputId]="id"
        class="tw-mt-1"
        [ariaRequired]="required"
      />
      @if (rightLabel) {
        <label
          [for]="id"
          class="tw-ml-2 tw-pt-1 tw-cursor-pointer "
          [class]="classes"
          >{{ rightLabel }}
          @if (required) {
            <span aria-hidden="true"> *</span>
          }
        </label>
      }
    </div>

    @if (showHelpText) {
      <app-help-text [control]="control" [helpText]="helpText" />
    }
  `,
  styles: ``,
})
export class ToggleSwitchComponent extends BaseControlComponent {
  @Input()
  rightLabel: string;

  @Input()
  classes: string;
}
